import { render, staticRenderFns } from "./AddUserToTalkgroup.vue?vue&type=template&id=565b2d95&scoped=true"
import script from "./AddUserToTalkgroup.vue?vue&type=script&lang=js"
export * from "./AddUserToTalkgroup.vue?vue&type=script&lang=js"
import style0 from "./AddUserToTalkgroup.vue?vue&type=style&index=0&id=565b2d95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b2d95",
  null
  
)

export default component.exports